import React, {Fragment, useEffect} from 'react';
import {Tabs, PlusButton} from '../../../components';
import {Route, Switch} from 'react-router-dom';
import WebIcon from '@material-ui/icons/Web';
import FilterNoneIcon from '@material-ui/icons/FilterNone';
import LibraryBooksIcon from '@material-ui/icons/LibraryBooks';
import ScheduleIcon from '@material-ui/icons/Schedule';
import ShortTextIcon from '@material-ui/icons/ShortText';
import Templates from './Sections/Templates';
import ShortCodes from './Sections/ShortCodes';
import Sequences from './Sections/Sequences';
import Collections from './Sections/Collections';


export default function EmailSection(props){

  let plus_tabs=[{label:'Short Code', icon:<ShortTextIcon/>, action:()=>{props.history.push('/email/shortCodes/new')}}];
  let current_template_number=0;
  let current_sequence_number=0;
  if((props.workspace!=undefined && props.workspace.active_subscription!=undefined && props.workspace.active_subscription.max_templates>current_template_number) || (props.workspace!=undefined && props.workspace.free_account==true)){plus_tabs.push({label:'Template', icon:<WebIcon/>, action:()=>{props.history.push('/email/templates/new')}})}else{plus_tabs.push({label:'Template (subscription only)', icon:<WebIcon/>, action:()=>{}})}
  if((props.workspace!=undefined && props.workspace.active_subscription!=undefined && props.workspace.active_subscription.max_sequences>current_sequence_number) || (props.workspace!=undefined && props.workspace.free_account==true)){plus_tabs.push({label:'Sequence', icon:<ScheduleIcon/>, action:()=>{props.history.push('/email/sequences/new')}})}else{plus_tabs.push({label:'Sequence (subscription only)', icon:<ScheduleIcon/>, action:()=>{}})}

  return(
    <Fragment>
      <Tabs {...props} white tabs={[{title:'Short codes', path:'/email/shortCodes'},{title:'Templates', path:'/email/templates'},{title:'Sequences', path:'/email/sequences'}]}/>
      <Switch>
        <Route path='/email/shortCodes'render={(route)=><ShortCodes {...route} {...props}/>}/>
        <Route path='/email/templates' render={(route)=><Templates {...route}{...props}/>}/>
        <Route path='/email/sequences' render={(route)=><Sequences {...route} {...props}/>}/>
      </Switch>
    </Fragment>
  );
}
